(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$urlRouterProvider'];

    function stateConfig($stateProvider,$urlRouterProvider) {
        $stateProvider.state('vl.dashboards', {
            abstract: true,
            parent: 'vl',
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('vassar');
                    return $translate.refresh();
                }]
            }
        });
        var today = new Date();

        // if(today.getHours()<= 9 || today.getHours() >=14){
        //     $urlRouterProvider.when('/','/revenue');
        // }
        // else{
        //   $urlRouterProvider.when('/','/blocked');
        // }
        $urlRouterProvider.when('/','/revenue');
        $urlRouterProvider.when('/cdma','/revenue');
        $urlRouterProvider.when('/cdma/','/revenue');

    }
})();